module.exports = __webpack_public_path__ + "img/guotai.f19aaccc.jpeg";